// extracted by mini-css-extract-plugin
module.exports = {"centeredDiv":"_975b061f"};